// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ListArrow_wrapper__2xKMj","header":"ListArrow_header__23sL8","left":"ListArrow_left__2eHu7","right":"ListArrow_right__2Hjc_"};